import {Component} from '@angular/core';

@Component({
  selector: 'app-ai-based-audio-processing',
  templateUrl: './ai-based-audio-processing.component.html',
  styleUrls: ['./ai-based-audio-processing.component.css']
})
export class AiBasedAudioProcessingComponent {
}
